module.exports = __webpack_public_path__ + "img/img_thanks.09bab580.png";